export default __webpack_public_path__ + "static/insta3@2x-48dc2efe6aef2f0f92a26b50addcc1c7.jpg";